/* tslint:disable */
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ServiceProvider } from 'providers/service/service';
import { GenProvider } from 'providers/gen/gen';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs/Rx';

@Component({
  selector: 'app-dashboard',
  templateUrl: './full-layout.component.html'
})
export class FullLayoutComponent implements OnInit {
  bsModal: BsModalRef;
  @ViewChild('frmModal') frmModal: ModalDirective;
  @ViewChild('audio') audio: ElementRef;
  iconCollapse: string = "fa fa-fw fa-toggle-off";
  isCollapsed: boolean = false;
  icononLine: string = "fa fa-fw fa-toggle-off";
  isonLine: boolean = false;
  parametros: any = {
    grupo: null,
    instancia : null
  };
  subscrib: any;
  alerta: any;
  isIcon = false;
  isMostraOnline = false;
  iconLed = "fa fa-fw fa-circle";
  sugestao = 0;
  pathNotificacao = '../../assets/sons/whatsapp.mp3'
  atendimento: number = 0;
  classificado: number;
  subscription: any;
  cliente: number;
  time: any;
  status = {
    accountStatus: null,
    connected: null,
    authenticated: null,
    battery: null,
    charging: null,
    charge: null,
    qrCode: null
  }
  isLog: {};
  whatscall: number;
  whatsSender: number;
  contrato: number;
  mensagem: number;
  chatSetor: number;
  ouvidoria: number;
  denuncia: number;
  path: any;
  contatoOnline: number;
  contatoOnlineDenuncia: number;
  isNotificacao: boolean = false;
  icononNotificacao = "fa fa-fw fa-toggle-off";
  contador: any;
  isGravarPergunta: boolean = false;
  constructor(
    private service: ServiceProvider,
    private genProvider: GenProvider,
    private router: Router
  ) {

  }
  ngOnInit() {
    // this.service.onConfig();
    // console.log(this.estados)
   // this.onContador();
    setTimeout(() => {
      console.log ("inicio")
      this.parametros = this.genProvider.parametros;
      this.path = this.parametros.path.toUpperCase();

      if (this.parametros.nivel == '99') {
        this.isMostraOnline = true;
     //   this.onStatus();
      } else {
        this.isMostraOnline = false;
      }
      if ((this.parametros.grupo == 'Atendimento') || (this.parametros.grupo == 'Administrador')) {
      //  this.onAtendimento();
      //  this.onMensagens();
      //  this.onDenuncia();
      //  this.onChat();
     //   this.onContatoOnline();
    //    this.onContatoOnlineDenuncia();
      }
      if ((this.parametros.grupo == 'Ouvidoria') || (this.parametros.grupo == 'Administrador')) {
   //     this.onOuvidoria();
      }
  //    this.onStatus();
   //   this.onLine();
    //  this.onStatusConexao();
   //   this.onWhatsCall();
      //      this.onWhatsSender();
      //     this.onContrato();
      //    this.onHoraAtual();
      //   this.onAlerta();
    }, 5000);

  }
  onContador(){
 //    this.service.console().subscribe(res=>{
 //     this.contador = res
  //  })
  }
  onGravarPergunta(){
    if (this.parametros.nivel == '99') {
      this.isGravarPergunta = !this.isGravarPergunta;
 //     this.isGravarPergunta = this.isGravarPergunta ? "fa fa-fw fa-toggle-on" : "fa fa-fw fa-toggle-off";
      this.service.onGravarPergunta();
    }
  }
  onMensagens() {
    this.genProvider.onGetfilter('dados/' + this.parametros.path + '/mensagem/', 'status', 'Nova')
      .subscribe(
        data => {
          this.mensagem = data.length;
          this.notificacao();
        },
        err => {
          if (!err.ok) {
            console.log('o erro ', err)
          }
        }
      );
  }
  onChat() {
    this.genProvider.onGetfilter('dados/' + this.parametros.path + '/chatSetor/', 'status', 'Nova')
      .subscribe(
        data => {
          this.chatSetor = data.length;
          this.notificacao();
        },
        err => {
          if (!err.ok) {
            console.log('o erro ', err)
          }
        }
      );
  }
  onDenuncia() {
    this.genProvider.onGetfilter('dados/' + this.parametros.path + '/denuncia/', 'status', 'Nova')
      .subscribe(
        data => {
          this.denuncia = data.length;
          this.notificacao();
        },
        err => {
          if (!err.ok) {
            console.log('o erro ', err)
          }
        }
      );
  }
  onOuvidoria() {
    this.genProvider.onGetfilter('dados/' + this.parametros.path + '/ouvidoria/', 'status', 'Nova')
      .subscribe(
        data => {
          this.ouvidoria = data.length;
          this.notificacao();
        },
        err => {
          if (!err.ok) {
            console.log('o erro ', err)
          }
        }
      );
  }
  onAtendimento() {
    this.genProvider.onGetfilter('dados/' + this.parametros.path + '/atendimento/', 'status', 'Nova')
      .subscribe(
        data => {
          this.atendimento = data.length;
          this.notificacao();
        },
        err => {
          if (!err.ok) {
            console.log('o erro ', err)
          }
        }
      );
  }
  onContatoOnlineDenuncia() {
    this.genProvider.onGetfilter('dados/' + this.parametros.path + '/contatoOnline/', 'menu', 'Denúncia Anônima')
      .subscribe(
        data => {
          this.contatoOnlineDenuncia = data.length;
        },
        err => {
          if (!err.ok) {
            console.log('o erro ', err)
          }
        }
      );
  }

  onContatoOnline() {
    this.genProvider.onGetAll('dados/' + this.parametros.path + '/contatoOnline/', "telefone")
      .subscribe(
        data => {
     //     console.log(data)
          this.contatoOnline = data.length;
        },
        err => {
          if (!err.ok) {
            console.log('o erro ', err)
          }
        }
      );
  }
  onWhatsCall() {
    this.genProvider.onGetfilter('dados/' + this.parametros.path + '/primeiro_atendimento/', 'status', 'Nova')
      .subscribe(
        data => {
          this.whatscall = data.length;
          this.notificacao();
        },
        err => {
          if (!err.ok) {
            console.log('o erro ', err)
          }
        }
      );
  }
  onWhatsSender() {
    this.genProvider.onGetfilter('dados/' + this.parametros.path + '/primeiro_atendimento/', 'status', 'Respondeu...')
      .subscribe(
        data => {
          this.whatsSender = data.length;
          //   this.notificacao();
        },
        err => {
          if (!err.ok) {
            console.log('o erro ', err)
          }
        }
      );
  }

  onClassificado() {
    if (!this.service.isonLine) {
      this.subscription = this.genProvider.onGetfilter('dados/' + this.parametros.path + '/classificado', 'status', 'Nova')
        .subscribe(
          data => {
            //        this.subscription.unsubscribe();
            this.classificado = data.length;
            this.notificacao();
          },
          err => {
            if (!err.ok) {
              console.log('o erro ', err)
            }
          }
        );

    } else {
      this.subscription.unsubscribe();
    }

  }
  onSugestao() {
    this.genProvider.onGetfilter('dados/' + this.parametros.path + '/mensagem/', 'status', 'Nova')
      .subscribe(
        data => {
          this.sugestao = data.length;
          this.notificacao();
        },
        err => {
          if (!err.ok) {
            console.log('o erro ', err)
          }
        }
      );
  }
  onStart() {
    if (this.parametros.nivel == '99') {
      this.isonLine = !this.isonLine;
      this.icononLine = this.isonLine ? "fa fa-fw fa-toggle-on" : "fa fa-fw fa-toggle-off";
      this.service.onStart();
    }

  }
  onStartNotificacao() {
    if (this.parametros.nivel == '99') {
      this.isNotificacao = !this.isNotificacao;
      this.icononNotificacao = this.isNotificacao ? "fa fa-fw fa-toggle-on" : "fa fa-fw fa-toggle-off";
      this.service.onBot();
    }
  }

  onLine() {
    this.genProvider.onGetfilter('whatsPost/', 'instanceId', this.parametros.instancia)
      .subscribe(
        data => {
          this.isIcon = true;
          this.iconLed = this.isIcon ? "fa fa-fw fa-circle" : "fa fa-fw fa-circle";
          setTimeout(() => {
            this.isIcon = false;
            this.iconLed = this.isIcon ? "fa fa-fw fa-circle" : "fa fa-fw fa-circle";
          }, 500);
        },
        err => {
          if (!err.ok) {
            console.log('o erro ', err)
          }
        }
      );
  }
  onLog() {
    this.service.onStartLog().then(res => {
      this.isLog = res;
    })
  }
  onStatus() {

    this.service.onStatus('status').then(res => {
      let data = JSON.parse(JSON.stringify(res));
      try {
        this.status = JSON.parse(data._body)
      } catch (error) {
        console.log("Erro ao ler status")
      }
      if (this.parametros.nivel == '99') {
        if (this.status.accountStatus != 'authenticated') {
          /*
          this.showModal();
          setTimeout(() => {
            this.hidedModal();
            this.service.onStatus('status').then(res=>{
              let data = JSON.parse(JSON.stringify(res));
              this.status = JSON.parse(data._body)
            })
          }, 15000);
          */
        }
      }
    })
  }
  notificacao() {
    this.audio.nativeElement.play();
  }
  ngAfterViewInit() {
    // console.log(this.audio.nativeElement);
  }
  goChatSetor() {
    this.router.navigate(['chatSetor']);
  }
  goAtendimento() {
    this.router.navigate(['atendimento']);
  }
  goDenuncia() {
    this.router.navigate(['denuncia']);
  }
  goClassificado() {
    this.router.navigate(['classificado']);
  }
  goWhatsCall() {
    this.router.navigate(['whatscall']);

  }
  goMensagem() {
    this.router.navigate(['mensagem']);
  }
  goOuvidoria() {
    this.router.navigate(['ouvidoria']);
  }

  showModal() {
    this.frmModal.show();
  }

  hidedModal() {
    this.frmModal.hide();
  }
  onHoraAtual() {
    this.horaAtual().subscribe(res => {
      this.time = res
    })
  }
  horaAtual() {
    console.log('aki')
    return (this.time = new Observable(observer => {
      setInterval(() => {
        console.log(new Date().toString())
        observer.next(new Date().toString());
      }, 1000);
    }));
  }
  onStatusConexao() {
    this.statusConexao().subscribe()
  }
  statusConexao() {
    return (this.time = new Observable(observer => {
      setInterval(() => {
        this.onStatus();
      }, 1000 * 60 * 5);
    }));
  }

  onAlerta() {
    /*
    return (this.alerta = new Observable(observer => {
    setTimeout(()=> {
      console.log( 'Executa uma vez após 1 segundo.' );
      }, 1000 );

      let i = setInterval( function() {
      console.log( 'Executa infinitamente, 1 vez por segundo.' );
    }, 1000 );

   // clearInterval(i);
    }));
    */
  }
}



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/app/containers/full-layout/full-layout.component.ts